"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.replaceWithX = replaceWithX;

function replaceWithX(str) {
  if (typeof str !== 'string' || !str) return '';
  return str.replace(/[\w\W]/g, 'X');
}